module.exports = __webpack_public_path__ + "img/undraw_void.7ed54f1e.svg";